import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import { serviceStatus } from '../../lib/service-status';
import { Button } from '../../ui';

/**
 * Supabase refuses writes (P12, spec §18.4: restricted project or read-only database): said once, in words, over
 * every screen. The open board keeps syncing through its room; renames, shares and the like wait for the service.
 */
export function ReadOnlyService() {
  const { t } = useTranslation();
  const readOnly = useSyncExternalStore(serviceStatus.subscribe, serviceStatus.readOnly);
  if (!readOnly) return null;
  return (
    <div className="pointer-events-none fixed inset-x-4 top-16 z-40 flex justify-center">
      <div role="alert" className="pointer-events-auto flex max-w-md items-start gap-3 rounded-lg border border-accent bg-surface p-3 font-sans text-sm text-fg shadow-lg">
        <p>{t('service.readOnly')}</p>
        <Button variant="ghost" size="sm" onClick={serviceStatus.clear}>
          {t('common.close')}
        </Button>
      </div>
    </div>
  );
}
